var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":100,"color":"primary","indeterminate":""}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }